import React from "react";
import { Link } from "react-router-dom";
import "../CSS/Blog.css";
import heroBg from "../Assets/bgimage.jpg";

import blog1 from "../Assets/blog1.png";
import blog2 from "../Assets/blog2.png";
import blog3 from "../Assets/blog3.png";

export default function Blog() {

  const blogs = [
  {
    slug: "documents-required-for-apostille-india",
    title: "Documents Required for Apostille in India",
    date: "07-04-2026",
    image: blog3,
    desc: "Apostille is a crucial process for document legalization when you plan to use your documents internationally. Whether you are going abroad for higher education, employment, or business purposes, understanding the documents required for apostille in India is essential for a smooth process."
  },
  {
    slug: "apostille-vs-attestation-difference",
    title: "Apostille vs Attestation: Key Differences Explained",
    date: "05-04-2026",
    image: blog2,
    desc: "When planning to use Indian documents abroad, you will encounter two terms: Apostille and Attestation. While both are methods of document legalization, they differ significantly in process, purpose, and applicable countries. Understanding these differences is crucial for choosing the right service for your needs."
  },
  {
    slug: "what-is-apostille-complete-guide-india",
    title: "What is Apostille? Complete Guide for Documents in India",
    date: "02-04-2026",
    image: blog1,
    desc: "Apostille is a term that has gained significant importance in recent years as more Indians travel abroad for education, employment, and immigration. If you are planning to use your Indian documents internationally, understanding apostille is crucial. This comprehensive guide will explain everything you need to know about apostille in India."
  }
];

  return (
    <div className="blog-page">

      {/* HERO */}
      <section
        className="blog-hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="blog-hero-content">
          <h1>Our Blogs</h1>
          <p>Insights, Updates & Expert Knowledge</p>
        </div>
      </section>

      {/* BLOG GRID */}
      <section className="blog-section">
        <div className="container">
          <h2 className="section-title">Latest Articles</h2>

          <div className="blog-grid">
            {blogs
  .sort((a, b) => new Date(b.date) - new Date(a.date)) // latest first
  .map((blog) => (
              <div className="blog-card" key={blog.id}>
                
                <Link to={`/blog/${blog.slug}`}>
                <div className="blog-image">
                  <img src={blog.image} alt={blog.title} />
                  <span className="blog-date">📅 {blog.date}</span>
                </div>
                </Link>

                <div className="blog-content">
                  <h3>{blog.title}</h3>
                  <p>{blog.desc}</p>

                  <Link to={`/blog/${blog.slug}`} className="read-more">
                    Read More →
                  </Link>
                </div>

              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}